import NotFound from './NotFound';
export { NotFound };
export default NotFound;
